<template>
	<div>
		<loader />
		<popup-detail 
			id_ref="warning"
    	direction="bottom" 
    	:show="show_error"
    	use_max_size
    	wrapper_size="mobile"
    	use_footer
    	no_close_backdrop>
    	<template v-slot:body>
    		<div class="py-5 px-4 text-center">
    			<img-default />
	    		<p class="w-75 mt-4 mx-auto body-2-2">{{error}}</p>
	    	</div>
    	</template>
    	<template v-slot:footer>
	    	<div class="px-3 pt-3">
	    		<button 
	    			@click="goToHomePage"
						class="g-btn g-btn-primary g-btn-lg w-100" >
						Homepage
					</button>
				</div>
	    </template>
    </popup-detail>
	</div>
</template>
<script>
	import {mapMutations,mapGetters,mapActions} from 'vuex';
	import {post,get} from '@/services/index.js'
	import moment from 'moment';
	
	export default{
		data(){
			return{
				is_load: true,
				error: '',
				temp_user: {}
			}
		},
		computed:{
			...mapGetters(['getMerchant','getConciergeAuth']),
			url_param(){
				return this.$route.query
			},
			show_error(){
				return this.error != ''
			}
		},
		mounted(){
			this.authGuest()
		},
		methods:{
			...mapMutations(['setConciergeAuth','resetConciergeAuth','logout','setReservationActive']),
			...mapActions(['logout','setToken','setUser']),
			authGuest(){
				this.is_load = true
				let is_url_valid = this.$isNotEmpty(this.url_param.booking_number) && this.$isNotEmpty(this.url_param.pin)
				if(is_url_valid){
					this.loginUser()
						.then(res=>{
							this.temp_user = res
							this.getReservationList()
								.then(resv_res =>{
									this.validateReservation(resv_res)
										.then(valid_rsv=>{
											this.setReservationActive('reset')
											let params_vuex = [
												{ key : 'booking_number', value: valid_rsv.booking_number },
												{ key : 'detail_id', value: valid_rsv.pms_detail_id },
												{ key : 'folio', value: valid_rsv.folio_number },
												{ key : 'user_id', value: valid_rsv.guest_profile.user }
											]
											this.setReservationActive(params_vuex)
											this.logout()
											this.setToken({
												access: this.temp_user.access_token,
												refresh: this.temp_user.refresh_token
											})
											this.setUser(res.user)
											setTimeout(()=>{
												this.goToHomePage()
											},300)
										})
										.catch(valid_rsv_err=>{
											let error_message = ''
											if(valid_rsv_err == 'not-found'){
												error_message = "Sorry we couldn't find any active reservations from your url"
											}else if (valid_rsv_err == 'invalid-status'){
												error_message = "Your reservation status is inactive. Please contact our staff for more detailed information"
											}else if(valid_rsv_err == 'invalid-stay-date'){
												error_message = "Your period of stay on this reservation has expired"
											}
											this.error = `Authentication failed. ${error_message}`
										}).finally(()=>this.is_load = false)
								})
								.catch(resv_err=>{
									this.error = 'Authentication failed. Make sure the reservation is still active'
									this.is_load = false
								})
						})
						.catch(err => this.error = err)
				}else{
					this.error = 'Authentication failed. Make sure the url you visit is correct'
					this.is_load = false
				}
			},
			loginUser(){
				return new Promise((success,fail)=>{
					let api_param = {
						booking_number: this.url_param.booking_number,
						pin: this.url_param.pin 
					}
					post('BASE','auth/reservation', api_param).then(response=>{
						let res = response.data
            console.log("TEST", res)
						if(res.access_token){
							success(res)
						}else{
							fail(res.message)
						}
					})
				})
			},
			getReservationList(){
				return new Promise((success,fail)=>{
					let params = {
						merchant_id: this.getMerchant.id,
						status: 'NEW_RESERVATION,SUBMIT_FORM,PRE_CHECKIN,CHECKIN,CHECKOUT,CANCELLED',
						datetime_type: 'NO_USE_FILTER_DATE',
						start_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
						end_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
						page_size: 100,
						page: 1
					}

					let temp_token = {
						type: 'token_direct',
						token: this.temp_user.access_token
					}
					
					get("CONCIERGE",'reservation',params,temp_token).then(response=>{
						let res = response.data
						if(res.success){
							success(res.data)
						}else{
							fail(res.message)
						}
					})
				})
			},
			validateReservation(rsv_list){
				return new Promise((success,fail)=>{
					let selected_rsv_index = rsv_list.findIndex(x=>x.booking_number == this.url_param.booking_number)
					if(selected_rsv_index != -1){
						let selected_rsv = rsv_list[selected_rsv_index]
						let active_status = ['SUBMIT_FORM','PRE_CHECKIN','CHECKIN']
						let is_rsv_active = active_status.some(x=>x == selected_rsv.status)

						if(is_rsv_active){
							let today_end = moment().endOf("day").toDate()
							let end_day_departure = moment(selected_rsv.departure_date,'YYYY-MM-DD').endOf("day").toDate()
							let valid_departure_date = moment(today_end).isBefore(end_day_departure)
							if(valid_departure_date){
								success(selected_rsv)
							}else{
								fail('invalid-stay-date')
							}
						}else{
							fail('invalid-status')
						}
					}else{
						fail('not-found')
					}
				})
			},
			goToHomePage(){
        this.$router.push(`/${this.getMerchant.code}`)
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/ConciergeDirectAuth.vue